/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_New_Shipment_BtnInputs */

const tr_geliver_tracking_new_shipment_btn = /** @type {(inputs: Geliver_Tracking_New_Shipment_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni Gönderi`)
};

const en_geliver_tracking_new_shipment_btn = /** @type {(inputs: Geliver_Tracking_New_Shipment_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Shipment`)
};

const de_geliver_tracking_new_shipment_btn = /** @type {(inputs: Geliver_Tracking_New_Shipment_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Sendung`)
};

const ru_geliver_tracking_new_shipment_btn = /** @type {(inputs: Geliver_Tracking_New_Shipment_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое отправление`)
};

/**
* | output |
* | --- |
* | "New Shipment" |
*
* @param {Geliver_Tracking_New_Shipment_BtnInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_new_shipment_btn = /** @type {((inputs?: Geliver_Tracking_New_Shipment_BtnInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_New_Shipment_BtnInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_new_shipment_btn(inputs)
	if (locale === "de") return de_geliver_tracking_new_shipment_btn(inputs)
	if (locale === "ru") return ru_geliver_tracking_new_shipment_btn(inputs)
	return tr_geliver_tracking_new_shipment_btn(inputs)
});